export default __webpack_public_path__ + "static/media/pen.a60b2937.png";